<template>
  <ul class="hornet-menu-list" :style="{'width': width+'px'}">
    <li v-for="group in list" :key="group.id">
      <div class="item" 
        :class="{
          'min-item':isMin, 
          'item-group-active': currentMenu.parent_id == group.id,
          'show-item-group': !isMin && openGroupId == group.id
        }"
        @click.stop="handleGroup(group)"
      > 
        <div class="item-icon">
          <span 
            data-hornet-hint-scroll-id="menu-child-wrap" 
            :data-hornet-hint="group.name" class="icon iconfont" 
            :class="icons[group.url] || 'icon-wenhao'" 
            style="font-size:22px"
          ></span>
        </div>
        <div class="item-name">{{group.name}}</div>
        <div class="item-icon item-icon-pos"><i class="el-icon-arrow-down" style="font-size:16px"></i></div>
      </div>
      <!-- <ul class="child-menu" :style="!isMin && openGroupId == group.id ?'height:'+ group.menuChildLength * 54 +'px;':''"> -->
      <ul class="child-menu" :style="!isMin && openGroupId == group.id ?'max-height:2000px;':'max-height:0;'">
        <template v-for="menu in group.children">
          <li :key="menu.id" v-if="!menu.hideMenu && !menu.is_group">
            {{'menu'+menu.id}}
            {{'currentMenu'+currentMenu.id}}
            <div :id="'item'+menu.id" class="item mm-item" :style="menu.id == currentMenu.id ? 'background: #2d8cf0;color: rgba(255,255,255,1);' : 'background: #101117;'" @click="handleMenu(menu,group)" >
              <div class="item-name">{{menu.name}}
                <span class="unreadNum" v-if="menu.name == '工单群聊' && $store.state.chat.unreadAll.group">{{$store.state.chat.unreadAll.group}}</span>
                <span class="unreadNum" v-if="menu.name == '工单私聊' && $store.state.chat.unreadAll.contact">{{$store.state.chat.unreadAll.contact}}</span>
              </div>
            </div>
          </li>
          <li :key="menu.id" v-if="menu.is_group">
            <div class="item -item-gary item-name" :class="{'show-item-group': showGroupIDs.indexOf(menu.id) != -1}" @click="handleChildGroup(menu)">{{menu.name}}<div class="item-icon item-icon-pos"><i class="el-icon-arrow-down" style="font-size:16px"></i></div></div>
            <ul class="child-menu child-group-menu" :style="showGroupIDs.indexOf(menu.id) != -1 ?'max-height:999px;':'max-height:0;'">
              <li 
                v-for="gmenu in menu.children" 
                :id="'item'+gmenu.id" 
                :key="gmenu.id" 
                class="item mm-item" 
                :style="
                  gmenu.id == currentMenu.id ? 'background: #2d8cf0;color: rgba(255,255,255,1);' : 'background: #101117;'" 
                @click="handleMenu(gmenu,group)">
                {{gmenu.name}}
              </li>
            </ul>
          </li>
        </template>
      </ul>
    </li>
  </ul>
</template>

<script>
import GongYeSuPaiEvent from '@/monitor'
  export default {
    props: {
      width: {
        type: Number,
        default: () => 0
      },
      list: {
        type: Array,
        default: () => []
      },
      isMin: {
        type: Boolean,
        default: () => false
      }
    },
    data() {
      return {
        icons: {
          examination : 'icon-kaoshi',
          coupons     : 'icon-youhuiquan',
          // message     : 'icon-xiaoxishezhi',
          customer    : 'icon-kehuguanli',
          system      : 'icon-xitongguanli',
          dataFrame   : 'icon-shujukuangjia',
          job         : 'icon-gongdanguanli',
          // course      : 'icon-peixunkecheng',

          
          proceeds    : 'icon-shoukuanguanli',
          expenditure : 'icon-zhichuguanli',
          // news        : 'icon-xinwenguanli',
          // video       : 'icon-daka',
          market      : 'icon-shichang',
          chat        : 'icon-xiaoxishezhi',
          run         : 'icon-yunyingguanli',
          contract    : 'icon-hetongtiaokuan',
          salerManage : 'icon-salermanage',
          reportCenter: 'icon-baobiao',
          distributeJob: 'icon-paidanguanli',
        },
        currentMenu: {},
        openGroupId: '',
        showGroupIDs: []
      }
    },
    computed: {

    },
    watch: {
      isMin(val) {
        if (val) {
          this.openGroupId = this.currentMenu.parent_id
        }
      },
      'store.state.chat':{
        handle: function(newVal, oldVal) {
          return newVal;
        },
        deep: true
      }
    },
    created() {
      let obj = localStorage.getItem('GYSP_CURRENT_MENU')
      if (obj) {
        this.currentMenu = JSON.parse(obj)
        this.openGroupId = this.currentMenu.parent_id
        if (this.currentMenu.is_group_menu) {
          this.showGroupIDs.push(this.currentMenu.group_id)
        }
      }
      // console.log("currentMenu  unreadNum = ",this.currentMenu);
    },
    mounted() {
      let that = this
      GongYeSuPaiEvent.listen(GongYeSuPaiEvent.key.SET_CURRENT_MENU, function(menu) {
        that.currentMenu = menu
        that.openGroupId = menu.parent_id
      })
    },
    methods: {
      handleMenu(menu, group) {
        if (this.$route.meta.menuId != menu.id) {
          this.openGroupId = group.id
          this.currentMenu = menu
          this.$router.push(menu.path)
        }
      },
      handleGroup(group) {
        if (this.openGroupId == group.id) {
          this.openGroupId = ''
        } else {
          this.openGroupId = group.id
        }
      },
      handleChildGroup(group) {
        let index = this.showGroupIDs.indexOf(group.id)
        if (index == -1) {
          this.showGroupIDs.push(group.id)
        } else {
          this.showGroupIDs.splice(index,1)
        }
      },
    }
  }
</script>

<style lang="scss">
.hornet-menu-list {
  transition: all .2s;
  width: 0;
  .item {
    width: 100%;
    height: 54px;
    padding: 0 24px;
    display: flex;
    position: relative;
    align-items: center;
    box-sizing: border-box;
    cursor: pointer;
    color: rgba(255,255,255,.7);
    transition: all .2s;
    background: #191a23;
    &:hover {
      color: rgba(255,255,255,1);
    }
    .item-icon {
      width: 24px;
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 8px;
    }
    .icon {
      transition: all .2s;
      transform: scale(1);
    }
    .item-name {
      white-space: nowrap;
      user-select:none;
    }
    .item-icon-pos {
      position: absolute;
      right: 0;
      top: 50%;
      transition: all .2s;
      transform: translateY(-50%);
    }
  }
  .item-group-active {
    color: rgba(255,255,255,1);
  }
  .show-item-group {
    .item-icon-pos {
      transform: translateY(-50%) rotate(180deg);
    }
  }
  .min-item {
    padding: 0 28px;
    .item-name {
      display: none;
    }
    .item-icon {
      margin-left: 0;
    }
    .icon {
      transform: scale(1.2);
    }
    .item-icon-pos {
      display: none;
    }
  }
  .child-menu {
    transition: all .2s;
    overflow: hidden;
    // height: 0;
    li {
      font-size: 0;
    }
    .item {
      padding-left: 72px;
      background: #101117;
      font-size: 14px;
    }
    .item-active {
      background: #2d8cf0;color: rgba(255,255,255,1);
    }
  }
  
}
.unreadNum {
  display: inline-block;
  background-color: #f04134;
  color: white;
  height: 18px;
  padding: 0 6px;
  line-height: 18px;
  text-align: center;
  border-radius: 10px;
  margin-left: 5px;
  font-size: 12px;
}
</style>